import React, { useContext } from 'react';

import { Button, Grid, Grid2, GridItem, Typography } from '@riac/design-system';
import { HeadContext } from 'src/lib/HeadContext';


export const Page404 = (): JSX.Element => {
  const head = useContext(HeadContext);

  head.is404Error = true;

  return head.isHead != true
    ? (
      <Grid2>
        <div className='h-[75vh] w-full flex items-center justify-center'>
          <div className='max-w-prose flex flex-col gap-6'>
            <Typography weight='bold' color='primary'>Something went wrong</Typography>
            <Typography display size='lg'>We're sorry - we can't find the page you're looking for.</Typography>
            <div className='flex flex-col gap-10 items-start'>
              <Typography size='lg' className='text-text-light'>The page may have been moved, removed, or the link you followed is outdated. Please return to the home page to continue browsing.</Typography>
              <Button to='/'>Return Home</Button>
            </div>
          </div>
        </div>
      </Grid2>
    )
    : <></>;
};
